import { Injectable } from '@angular/core';
import { CourseModel, StudentCourseModel } from '../models';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { BaseFucntionsService } from 'src/app/@core/services/base-functions.service';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';

@Injectable({
  providedIn: 'root',
})
export class CourseService extends BaseFucntionsService<CourseModel> {
  constructor(apiClient: ApiClientService) {
    super(ApplicationRoutes.Course.Courses, apiClient);
  }

  getSections(courseId: number) {
    return this.apiClient.get(`${ApplicationRoutes.Course.CourseSections(courseId)}`);
  }

  getCourseCertificate(courseId: number) {
    return this.apiClient.get(`${ApplicationRoutes.Course.CourseCertificate(courseId)}`);
  }

  getCourseAdvertisement(courseId: number) {
    return this.apiClient.get(`${ApplicationRoutes.Course.CourseAdvertisements(courseId)}`);
  }
  getCourseInstructorDetails(courseId: number) {
    return this.apiClient.get(`${ApplicationRoutes.Course.CourseInstructorsDetails(courseId)}`);
  }

  getCourseStatistics() {
    return this.apiClient.get(`${ApplicationRoutes.Course.DashboardInformation}`);
  }
}
